import { extractData } from 'utils/Sidebar';
import { chatAgent } from 'store/Agents';

const apiMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case 'persist/REHYDRATE':
      if (action?.payload?.rangeDate)
        action.payload.rangeDate = [new Date(action?.payload?.rangeDate[0]), new Date(action?.payload?.rangeDate[1])];
      next(action);
      break;
    case 'agents/setChatdata':
      // action.payload = store.getState().filter;

      next(action);

      store.dispatch(chatAgent(action.payload.paramsobj));

      break;
    case 'contacts/setAllFilterFromParent':
      action.payload = extractData(store.getState().list, ['rangeDate']);
      next(action);
      break;
    case 'auth/logout':
      next(action);
      break;
    default:
      next(action);
      break;
  }
};
export default apiMiddleware;
